import { Navigate, Route, Routes } from 'react-router-dom'
import { WebsitePage } from '@/features/website'
import ConsentBanner from '@/features/website/components/ConsentBanner'
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage'

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<WebsitePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ConsentBanner />
    </>
  )
}

export default App
